<!--设备属性编辑界面-->
<template>
	<roleBody>
		<!--左边-->
		<div slot="tree" style="width: 100%;">
			<div class="buttonLine"
			 :style="$store.resourcesStore.getters.getBackgroudImageStyle('iconButton/bar.png')" > 
			 <!--  :columns='entityColumns' -->
				<iconButton @buttonClick='addEntity' buttonText='添加角色' icoName="wedoButton/add.png"></iconButton>
				<iconButton @buttonClick='deleteEntity' buttonText='删除角色' icoName="wedoButton/delete.png"></iconButton>
				<iconButton @buttonClick='editEntity($event)' buttonText='编辑角色' icoName="wedoButton/edit.png"></iconButton>
				<iconButton @buttonClick='saveAuth' buttonText='保存' icoName="wedoButton/add.png"></iconButton>
			</div>
			<infoList   ref="entityList" style="height: 100%" :columns='roleColumns' :dataList="roleList" 
			:pageLen='roleList.length' :totalSize="10" :showIndex="false"  :fillAll="true" :checkedFirst="true"
			@checkItem="chooseRole($event)"
			></infoList>
		</div>
		<!--右边-->
		<div class="rightBody" slot="body">
			<div class="areaContainer">
					<div class="areaTitle">权限配置</div>
					<div class="tabsHeader">
						<div class="tabBtnsContainer">
							<button :class="{'tabActive':tabPage == 0}" @click="tabPageChange(0)">WEB权限</button>
							<button :class="{'tabActive':tabPage == 1}" @click="tabPageChange(1)">APP权限</button>
							<!-- <button :class="{'tabActive':tabPage == 2}" @click="tabPageChange(2)">系统权限</button> -->
						</div>
						<!-- <button class="saveEditBtn" @click="saveEdit">保存</button> -->
					</div>
					<!-- 用户权限（系统权限、web权限、App权限） -->
					<webRight ref="webRightView" v-show="tabPage == 0"></webRight>
					<appRight ref="appRightView" v-show="tabPage == 1"></appRight>
					<!-- <systemRight ref="systemRightView" v-show="tabPage == 2"></systemRight> -->
				</div>
		</div>
	</roleBody>
</template>

<script type="text/javascript">
	 let id = 1000;
	import tab from '@/components/module/tab/tab.vue'
	import roleBody from '@/components/module/slotModule/roleBody.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
	import webRight from '@/page/roleManager/webRight.vue'
	import appRight from '@/page/roleManager/appRight.vue'
	//import systemRight from '@/page/roleManager/systemRight.vue'
	import roleManagerStore from '@/page/roleManager/roleManagerStore.js'
	export default {
		components: {
			tab,
			roleBody,
			infoList,
			iconButton,
			webRight,
			appRight,
			//systemRight
		},
		props: [],
		data() {
			return {
				tabPage: 0,
				picked:false,//用户是否有勾选权限标识
				titleList:[{name:'名称'},{name:'图形文件'},{name:'网站页面'},{name:'描述'}],
				nowProperty: '',
				checkedList:[],//!!!!!勾选的 authList
				roleColumns:[
					{
						name: '名称',
						key: 'rolename'
					}, {
						name: '备注',
						key: 'memo'
					}
				],
			}
		},
		created() {
			debugPage = this
			
		},
		mounted() {
			//预获取一些数据
			// this.doQuery();
		},
		destroyed() {},
		computed: {
			userSelected() {
				return roleManagerStore.state.nowRole
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			roleList() {
				return this.$store.roleStore.getters.getRoleList
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			archivesStore() {
				return this.$store.archivesStore
			},
			getEnumByEnumCode() {
				return this.$store.enumStore.getters.getEnumByEnumCode
			},
			getValueTypeText() {
				return this.archivesStore.getters.getValueTypeText
			},
			getAlignText() {
				return this.archivesStore.getters.getAlignText
			},
			entityInfo() {// 加载对应单位的用户列表
				var info = copy(this.nowEntity)
				info.editable = info.editable == 1 ? "是" : "否"
				return [info]
			},
			entityInfoLen() {
				var info = copy(this.nowEntity)
				return [info].length;
			},
		},
		watch: {
			nowProperty:{
				handler(nv,ov ) {
				},
				immediate: true,
				deep: true
			},
			
		},
		methods: {
			// 分页切换
			tabPageChange(i){
				if(this.tabPage == i){
					return
				}
				if(i == 0){
					if(this.$refs.appRightView.needSave){
						this.$dialogMethod.openAgreeDialog("有修改尚未保存", "是否进行保存后再离开", confirm => {
							return
						}, cancel => {
							this.tabPage = i
							this.$refs.appRightView.resetDatas()
						}, true)
					}else{
						this.tabPage = i
						this.$refs.appRightView.resetDatas()
					}
				}else{
					if(this.$refs.webRightView.needSave){
						// 弹窗确认是否进行保存
						this.$dialogMethod.openAgreeDialog("有修改尚未保存", "是否进行保存后再离开", confirm => {
							return
						}, cancel => {
							this.tabPage = i
							this.$refs.webRightView.coverCheckedIds()
						}, true)
					}else{
						this.tabPage = i
						this.$refs.webRightView.coverCheckedIds()
					}
				}
			},
			getAndSetRightsByRoleId(roleid) {
				this.$api.menuApi.getRightsByRoleIds(roleid,
					respon=>{
						this.checkedList = respon;
						//this.$refs.elt.setCheckedKeys(respon)
					},respon=>{
						this.checkedList =[]
						this.$dialogMethod.showMessage(respon)
						//this.$refs.elt.setCheckedKeys([])
					})
			},
			chooseRole(item) {
				if (!isempty(item)) {
					roleManagerStore.commit('setUnit', this.nowUnit)
					if(item == undefined){
						roleManagerStore.commit('setRole', {})
					}else if(this.userSelected.id == undefined || this.userSelected.id != item.id){
						roleManagerStore.commit('setRole', item)
					}
					this.getAndSetRightsByRoleId(item.roleid)
					this.nowProperty = item
				}
			},
			clean(){
				this.$store.roleStore.commit('cleanRole')	
			},
			//初始化查询
// 			doQuery(){
// 			},
			pickItem(state,data){// data 对象   , state : true  false
				let had = this.checkedList.indexOf(data.id)>-1
				if (state && !had) {
						 this.checkedList.push(data.id)
						 let list = data.childRights;
						 for(let i = 0; i<list.length; i++){
							 this.pickItem(state,list[i])
						 }
				} else if(!state && had){
						let index = this.checkedList.indexOf(data.id)
						this.checkedList.splice(index,1)
						let list = data.childRights;
						for (let i = 0; i<list.length; i++) {
							this.pickItem(state,list[i])
						}
				}
				this.picked = true ;
			},
			saveAuth(){
				if(this.tabPage==0){
					this.$refs.webRightView.saveEdit()
				}else{
					this.$refs.appRightView.saveEdit()
				}
			},
			addEntity(mainCode) {
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('添加角色', [{
					name: '名称',
					pkid: 'rolename'
				}, {
					name: '备注',
					pkid: 'memo'
				}], item => {
					this.$api.roleApi.saveRole('',item.rolename,item.memo,respon => {
							this.$dialogMethod.showMessage("添加成功!")
							this.nowProperty='';
							this.clean()
					},respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			deleteEntity() {
				if(!this.nowProperty){
					this.$dialogMethod.showMessage("请选择一项!")
					return
				}
				this.$dialogMethod.openAgreeDialog('提示信息', "确定要删除 " + this.nowProperty.rolename, () => {
					this.$api.roleApi.deleteRole(this.nowProperty.roleid,respon => {
							this.$dialogMethod.showMessage("删除成功!")
							this.nowProperty='';
							this.clean()
							// this.doQuery()
					},respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			editEntity(data) {
				if(!this.nowProperty){
					this.$dialogMethod.showMessage("请选择一项!")
					return
				}
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('编辑类型', [{
					name: '名称',
					pkid: 'rolename',
					defaultValue:this.nowProperty.rolename
				},
				{
					name: '备注',
					pkid: 'memo',
					defaultValue:this.nowProperty.memo

				}
				], item => {
					let index = this.roleList.indexOf(this.nowProperty);
					if (index != -1) this.roleList[index] = item
					this.$api.roleApi.saveRole(this.nowProperty.roleid,item.rolename,item.memo,respon => {
							this.$dialogMethod.showMessage("保存成功!")
							this.nowProperty='';
							this.clean()
							// this.doQuery()
					},respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
		}
	}
</script>

<style scoped>
	/* .rightBody .iconButton-body {
		width: 1rem;
	} */
	
	.rightBody {
		width: 100%;
		height: calc(100% - 0.1rem);
		
	}
	.block{
		width:  100%;
	}
	.custom-tree{
		width: 100%;

	}
	  .custom-tree-node {
		  text-align: center;
			width: calc( 100% - 17px);
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 14px;
			/* padding-right: 8px; */
			/* border-bottom: 1px solid #000000; */
	  }
	  .custom-tree-node-ex{
		  width: 6rem;
		  display: flex;
		  align-items: center;
		  justify-content: space-around;
		  font-size: 14px;
		  padding-right: 8px;
	  }
	  .custom-tree-node-ex span{
		  flex:1;
		  border-left:1px solid #000000
	  }
	  .btn-group{
		  position: fixed;
		  bottom: 0.1rem;
		  right: 0.5rem;
		  display: flex;
		  align-content: center;
	  }
	  .tabsHeader{
		margin: 10px 5px;
		overflow: hidden;
	}
	.tabBtnsContainer{
		float: left;
		border: solid 2px #D1D1D1;
		border-radius: 16px;
	}
	
	.tabBtnsContainer>button{
		cursor: pointer;
		width: 100px;
		height: 30px;
		border-radius: 15px;
		background: #FFFFFF;
		color: #3D7EFF;
		outline: none;
	}
	
	.tabBtnsContainer>.tabActive{
		background: #3D7EFF;
		color: #FFFFFF;
		width: 110px;
	}
	>>>.tree{
		width: 5.3rem;
	}
	.areaTitle{
		font-size: .15rem;
		font-weight: 600;
		line-height: 16px;
		border-left: solid 4px #3D7EFF;
		padding-left: 8px;
		margin: 15px 10px;
		margin-bottom: 8px;
	}
</style>
